import { ICreateParcelModel } from "./i-create-parcel-model"
import { CreateParcelModelExtension } from "./extension/create-parcel-model-extension"
import { DpdProductVariant } from "./dpd-product/dpd-product-variant"
import { CreateParcelModelExtensions } from "./extension/create-parcel-model-extensions"
import { CreateParcelModelOptions } from "./option/create-parcel-model-options"
import * as _ from "lodash"
import { DpdProduct } from "./dpd-product/dpd-product"

export class CreateParcelModel implements ICreateParcelModel {
  private _country: string

  private _domesticCountry: string

  private _codCountries: string[]

  private _roadExportCountries: string[]

  private _weight: number

  private _dimension: string

  private _hrRoadExportCountries: string[]

  private _siRoadExportCountries: string[]

  _dpdProductVariants: DpdProductVariant[]

  filteredDpdProductVariants: DpdProductVariant[]

  _dpdProductVariant: DpdProductVariant

  private _dpdProduct: DpdProduct

  createParcelModelExtensions: CreateParcelModelExtensions
  createParcelModelOptions: CreateParcelModelOptions

  availableDpdProductVariants!: DpdProductVariant[]

  constructor(
    dpdProductVariants: DpdProductVariant[],
    dpdProduct: DpdProduct,
    country: string = "HR",
    domesticCountry: string = "HR",
    codCountries: string[] = ["HR"],
    roadExportCountries: string[] = ["HR"],
    weight: number = 0,
    dimension: string = ""
  ) {
    this._dpdProductVariants = dpdProductVariants
    this.filteredDpdProductVariants = dpdProductVariants
    this._dpdProduct = dpdProduct
    this._country = country
    this._domesticCountry = domesticCountry
    this._codCountries = codCountries
    this._roadExportCountries = roadExportCountries
    this._weight = weight
    this._dimension = dimension
    this.createParcelModelExtensions = new CreateParcelModelExtensions(this)
    this.createParcelModelOptions = new CreateParcelModelOptions(this)
    this._hrRoadExportCountries = [
      "IT",
      "SE",
      "GB",
      "BG",
      "CZ",
      "DK",
      "EE",
      "FI",
      "FR",
      "GR",
      "LV",
      "AT",
      "NL",
      "DE",
      "PL",
      "PT",
      "RO",
      "IE",
      "BE",
      "BA",
      "GG",
      "RS",
      "CH",
      "LT",
      "LU",
      "HU",
      "SK",
      "SI",
      "ES",
      "UA",
      "LI",
      "NO",
      "MC",
      "SM",
      "JE",
      "IM",
      "VA",
      "AD"
    ]
    this._siRoadExportCountries = [
      "IT",
      "SE",
      "GB",
      "BG",
      "CZ",
      "DK",
      "EE",
      "FI",
      "FR",
      "GR",
      "LV",
      "AT",
      "NL",
      "DE",
      "PL",
      "PT",
      "RO",
      "IE",
      "BE",
      "BA",
      "GG",
      "RS",
      "CH",
      "LT",
      "LU",
      "HU",
      "SK",
      "HR",
      "ES",
      "UA",
      "LI",
      "NO",
      "MC",
      "SM",
      "JE",
      "IM",
      "VA",
      "AD"
    ]
  }

  evaluateExpression<T>(expression: string): T {
    const result = {}

    const contextParams = {
      country: this.country,
      domesticCountry: this.domesticCountry,
      weight: this.weight,
      dimension: this.dimension,
      codCountries: this.codCountries,
      roadExportCountries: this.roadExportCountries
    }

    _.assign(result, contextParams, this.createParcelModelExtensions.context, this.createParcelModelOptions.context)

    const contextEntries = _.entries(result)
    const contextDefinitionExpression =
      _.map(contextEntries, pair => {
        const key = pair[0]
        const value = pair[1]
        const valueString = (() => {
          if (_.isArray(value)) {
            return "[" + value.map((v) => `'${v}'`).join(",") + "]"
          } else if (_.isString(value)) {
            return `'${value}'`
          } else {
            return value
          }
        })()
        return `const ${key} = ${valueString}`
      }).join(";") + ";"

    return eval(`(() => {${contextDefinitionExpression}; return ${expression}})()`)
  }


  consolidateVariantFromContext(createParcelModelExtension?: CreateParcelModelExtension) {
    this._dpdProductVariant = (() => {
      if (createParcelModelExtension) {
        if (createParcelModelExtension.value) {
          if (!this.filteredDpdProductVariants) {
            this.filteredDpdProductVariants = this._dpdProductVariants
          }
          this.filteredDpdProductVariants = _.filter(this.filteredDpdProductVariants, createParcelModelExtension.name)
        }
        if (!createParcelModelExtension.value) {
          const enabledExtensions = _.filter(this.createParcelModelExtensions, (obj) => {
            return obj.value
          })
          const filteredList = []
          enabledExtensions.forEach(element => {
            filteredList.push(_.filter(this._dpdProductVariants, element.name))
          })
          this.filteredDpdProductVariants = filteredList[0] || this._dpdProductVariants
        }
      }
      if (this.filteredDpdProductVariants.length === 0) {
        this.filteredDpdProductVariants = this._dpdProductVariants
      }
      let matchingDpdProductVariant = _.find(
        this.filteredDpdProductVariants,
        dpdProductVariant => dpdProductVariant.binary === this.createParcelModelExtensions.binary
        && (dpdProductVariant.parcelWeight === this.checkParcelWeight() || dpdProductVariant.parcelWeight === "ANY")
      )
      if (!_.isNil(matchingDpdProductVariant)) {
        return matchingDpdProductVariant
      }

      if (!_.isNil(createParcelModelExtension)) {
        matchingDpdProductVariant = _.find(this.filteredDpdProductVariants, dpdProductVariant => {
          const dpdProductVariantExtension: boolean =
            dpdProductVariant[createParcelModelExtension.name]
          return dpdProductVariantExtension && (dpdProductVariant.parcelWeight === this.checkParcelWeight()
            || dpdProductVariant.parcelWeight === "ANY")
        })

        if (!_.isNil(matchingDpdProductVariant)) {
          return matchingDpdProductVariant
        }
      }
      return _.first(this.filteredDpdProductVariants)!

    })()
    if (this._dpdProductVariant) {
      this.createParcelModelExtensions.initProductExtensions(this._dpdProductVariant)
      this.createParcelModelOptions.initWithProductVariant(this._dpdProductVariant)
    } else {
      this.createParcelModelExtensions = new CreateParcelModelExtensions(this)
      this.createParcelModelOptions = new CreateParcelModelOptions(this)
    }
  }

  checkParcelWeight() {
    if (this.weight === 0 || this.weight >= 3000 ) {
      return "NORMAL"
    } else {
      return "SMALL"
    }
  }

  get country() {
    return this._country
  }

  set country(value: string) {
    this._country = value
    this.consolidateVariantFromContext()
  }

  get domesticCountry() {
    return this._domesticCountry
  }

  set domesticCountry(value: string) {
    this._domesticCountry = value
  }

  get codCountries() {
    return this._codCountries
  }

  set codCountries(value: string[]) {
    this._codCountries = value
  }

  get roadExportCountries() {
    return this._roadExportCountries
  }

  set roadExportCountries(value: string[]) {
    this._roadExportCountries = value
  }

  get weight() {
    return this._weight
  }

  set weight(value: number) {
    this._weight = value
    this.consolidateVariantFromContext()
  }

  get dimension() {
    return this._dimension
  }

  set dimension(value: string) {
    this._dimension = value
  }

  get dpdProduct() {
    return this._dpdProduct
  }

  set dpdProduct(value: DpdProduct | undefined) {
    this._dpdProduct = value
  }

  get dpdProductVariants() {
    return this._dpdProductVariants
  }

  set dpdProductVariants(dpdProductVariants: DpdProductVariant[]) {
    this._dpdProductVariants = dpdProductVariants
  }

  get dpdProductVariant() {
    return this._dpdProductVariant
  }

  set dpdProductVariant(dpdProductVariant: DpdProductVariant) {
    this._dpdProductVariant = dpdProductVariant
  }
}
